// extracted by mini-css-extract-plugin
export default {"top":"TopBox_top__lsRBR"};